import React, { Component, Fragment } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { SelectField, InputField, CheckboxField } from 'Common/SemanticWrapper';
import { FieldEnum } from 'Common/FieldEnum';
import {
  normalizePhoneWithExtension,
  isValidEmail,
  normalizeZip4,
} from 'Common/FormHelper';
import { InputMode } from 'Common/FormEnum';
import StateDropdown from 'Common/Components/StateDropdown/StateDropdown';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';
import { TitledCard } from 'Components';

const alternateProvision = [
  { key: 'alt0', value: 0, text: 'None' },
  { key: 'alt1', value: 1, text: 'Prov2 Base' },
  { key: 'alt2', value: 2, text: 'Prov2 Non Base' },
  { key: 'alt3', value: 3, text: 'CEP' },
  { key: 'alt4', value: 4, text: 'NSLP and SBP Alt' },
  { key: 'alt5', value: 5, text: 'NSLP or SBP Alt' },
  { key: 'alt6', value: 6, text: 'Prov2 Non Base Breakfast Only' },
];

const siteType = [
  { text: 'School', key: 'school', value: 1 },
  { text: 'Warehouse', key: 'Warehouse', value: 2 },
  { text: 'Kitchen', key: 'Kitchen', value: 3 },
];
const orderPreference = [
  {
    text: 'Warehouse/Kitchen if Available',
    key: 'wareHouseKitchenIfAvailable',
    value: 1,
  },
  { text: 'Warehouse/Kitchen', key: 'wareHouseKitchen', value: 2 },
  { text: 'Distributor Direct', key: 'vendor', value: 3 },
];

class EditForm extends Component {
  static propTypes = {
    shippingAddress1: PropTypes.string,
    shippingAddress2: PropTypes.string,
    shipCity: PropTypes.string,
    shipZipCode: PropTypes.string,
    shipState: PropTypes.string,
    selectedSiteType: PropTypes.number,
    isBillAddSameAsShipAdd: PropTypes.bool,
    setIsValid: PropTypes.func,
  };
  static defaultProps = {
    shippingAddress1: '',
    shippingAddress2: '',
    shipCity: '',
    shipZipCode: '',
    shipState: '',
    selectedSiteType: 0,
    isBillAddSameAsShipAdd: false,
    setIsValid: () => {},
  };
  componentDidMount() {
    //Hack below
    //if previously got a redux form error, it would never reset
    this.props.setIsValid(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.valid !== this.props.valid) {
      this.props.setIsValid(this.props.valid);
    }
  }

  setSameAsShippingFlag = (event, newValue) => {
    if (newValue) {
      const {
        shipCity,
        shipState,
        shipZipCode,
        shippingAddress1,
        shippingAddress2,
        change,
      } = this.props;
      change(FieldEnum.BillAddress1, shippingAddress1);
      change(FieldEnum.BillAddress2, shippingAddress2);
      change(FieldEnum.BillCity, shipCity);
      change(FieldEnum.BillState, shipState);
      change(FieldEnum.BillZipCode, shipZipCode);
    }
  };
  onChangeAddress = (event, newValue) => {
    const { isBillAddSameAsShipAdd, change } = this.props;
    if (isBillAddSameAsShipAdd) {
      change(FieldEnum.IsBillAddSameAsShipAdd, false);
    }
  };

  onSiteTypeChange = (event, newValue) => {
    const { change } = this.props;
    if (SiteTypeEnum.School !== newValue) {
      change(FieldEnum.AlternateProvisionId, 0);
    }
  };

  render() {
    const {
      handleSubmit,
      siteGroups,
      selectedSiteType,
      isBillAddSameAsShipAdd,
      isNew,
    } = this.props;

    const transformedData = siteGroups.map((siteGroup, index) => {
      return {
        key: index,
        text: siteGroup.Description,
        value: siteGroup.Id,
      };
    });

    return (
      <Fragment>
        <Form onSubmit={handleSubmit}>
          <Grid padded>
            <Grid.Row>
              <TitledCard title={''}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.Id}
                        component={InputField}
                        type="text"
                        maxLength={8}
                        label={'Id'}
                        readOnly={!this.props.isNew}
                        autoFocus={this.props.isNew ? true : false}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.Description}
                        component={InputField}
                        type="text"
                        maxLength={30}
                        label={'Description'}
                        autoFocus={this.props.isNew ? false : true}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.IsLicensed}
                        component={CheckboxField}
                        label={'Licensed'}
                        toggle
                        maxLength={30}
                        disabled={true}
                      />
                      <Field
                        name={FieldEnum.IsActive}
                        component={CheckboxField}
                        toggle
                        label={'Active'}
                        maxLength={30}
                        disabled={this.props.isActiveDisabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.SiteGroupId}
                        component={SelectField}
                        type="text"
                        options={transformedData}
                        label={'Site Group'}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.SiteType}
                        component={SelectField}
                        type="text"
                        options={siteType}
                        label={'Site Type'}
                        onChange={this.onSiteTypeChange}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.Contact}
                        component={InputField}
                        type="text"
                        label={'Contact'}
                        maxLength={20}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.ManagersEmailId}
                        component={InputField}
                        type="text"
                        label={"Manager's Email"}
                        maxLength={50}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.Phone}
                        component={InputField}
                        type="text"
                        label={'Phone #'}
                        maxLength={50}
                        normalize={normalizePhoneWithExtension}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        label={'Meal Benefit Expiration'}
                        name={FieldEnum.MBEDate}
                        component={InputField}
                        type="text"
                        maxLength={20}
                        readOnly
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.AlternateProvisionId}
                        component={SelectField}
                        type="text"
                        options={alternateProvision}
                        label={'Alternate Provision'}
                        disabled={SiteTypeEnum.School !== selectedSiteType}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            {!isNew ? (
              <Grid.Row>
                <TitledCard title={'Enrollment'}>
                  <Grid>
                    <Grid.Row columns={4}>
                      <Grid.Column>
                        <Field
                          name={FieldEnum.Free}
                          component={InputField}
                          type="text"
                          label={'Free'}
                          readOnly={true}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Field
                          name={FieldEnum.Reduced}
                          component={InputField}
                          type="text"
                          label={'Reduced'}
                          readOnly={true}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Field
                          name={FieldEnum.Paid}
                          component={InputField}
                          type="text"
                          label={'Paid'}
                          readOnly={true}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Field
                          name={FieldEnum.Membership}
                          component={InputField}
                          type="text"
                          label={'Membership'}
                          readOnly={true}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>
              </Grid.Row>
            ) : null}
            <Grid.Row>
              <TitledCard title={'Shipping Address'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.ShipAddress1}
                        component={InputField}
                        type="text"
                        label={'Address 1'}
                        maxLength={30}
                        onChange={this.onChangeAddress}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.ShipAddress2}
                        component={InputField}
                        type="text"
                        label={'Address 2'}
                        maxLength={30}
                        onChange={this.onChangeAddress}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.ShipCity}
                        component={InputField}
                        type="text"
                        label={'City'}
                        maxLength={21}
                        onChange={this.onChangeAddress}
                      />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <StateDropdown
                        name={FieldEnum.ShipState}
                        onChange={this.onChangeAddress}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Field
                        name={FieldEnum.ShipZipCode}
                        component={InputField}
                        type="text"
                        label={'Zip +4'}
                        maxLength={10}
                        mode={InputMode.Integer}
                        onChange={this.onChangeAddress}
                        normalize={normalizeZip4}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            <Grid.Row>
              <TitledCard title={'Billing Address'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <Field
                        name={FieldEnum.IsBillAddSameAsShipAdd}
                        component={CheckboxField}
                        toggle
                        label={'Same as Shipping Address'}
                        onChange={this.setSameAsShippingFlag}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.BillAttention}
                        component={InputField}
                        type="text"
                        label={'Attention'}
                        maxLength={20}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.BillAddress1}
                        component={InputField}
                        type="text"
                        label={'Address 1'}
                        maxLength={30}
                        disabled={isBillAddSameAsShipAdd}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.BillAddress2}
                        component={InputField}
                        type="text"
                        label={'Address 2'}
                        maxLength={30}
                        disabled={isBillAddSameAsShipAdd}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.BillCity}
                        component={InputField}
                        type="text"
                        label={'City'}
                        maxLength={21}
                        disabled={isBillAddSameAsShipAdd}
                      />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <StateDropdown
                        name={FieldEnum.BillState}
                        disabled={isBillAddSameAsShipAdd}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Field
                        name={FieldEnum.BillZipCode}
                        component={InputField}
                        type="text"
                        label={'Zip +4'}
                        maxLength={10}
                        // pattern="[0-9]*"
                        mode={InputMode.Integer}
                        disabled={isBillAddSameAsShipAdd}
                        normalize={normalizeZip4}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            <Grid.Row>
              <TitledCard title={'Inventory'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.Route}
                        component={InputField}
                        type="text"
                        label={'Route'}
                        maxLength={15}
                      />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Field
                        name={FieldEnum.OrderPreferenceId}
                        component={SelectField}
                        upward
                        type="text"
                        options={orderPreference}
                        label={'Order Preference'}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (!values[FieldEnum.Id] || _.trim(values[FieldEnum.Id]).length === 0) {
    errors[FieldEnum.Id] = 'Id is required.';
  }

  if (
    !values[FieldEnum.Description] ||
    _.trim(values[FieldEnum.Description]).length === 0
  ) {
    errors[FieldEnum.Description] = 'Description is required.';
  }

  if (
    values[FieldEnum.ManagersEmailId] &&
    _.trim(values[FieldEnum.ManagersEmailId]).length > 0 &&
    !isValidEmail(values[FieldEnum.ManagersEmailId])
  ) {
    errors[FieldEnum.ManagersEmailId] = 'Please enter a valid email address.';
  }
  if (props.isNew === true) {
    const foundSite = _.find(props.siteSetup.Data, x => {
      return x.Id.toLowerCase() === values[FieldEnum.Id].toLowerCase();
    });
    if (foundSite) {
      errors[FieldEnum.Id] = 'The site id must be unique';
    }
  }
  if (values[FieldEnum.BillZipCode]) {
    const billZipCode = values[FieldEnum.BillZipCode].replace(
      /[^a-z0-9]+/g,
      ''
    );
    if (billZipCode.length !== 5 && billZipCode.length !== 9) {
      errors[FieldEnum.BillZipCode] = 'Please enter a valid Zip +4 code.';
    }
  }
  if (values[FieldEnum.ShipZipCode]) {
    const billZipCode = values[FieldEnum.ShipZipCode].replace(
      /[^a-z0-9]+/g,
      ''
    );
    if (billZipCode.length !== 5 && billZipCode.length !== 9) {
      errors[FieldEnum.ShipZipCode] = 'Please enter a valid Zip +4 code.';
    }
  }

  return errors;
};

const EditFormComponent = connect(state => {
  const selector = formValueSelector('SiteSetupForm');
  return {
    shippingAddress1: selector(state, 'shipAddress1'),
    shippingAddress2: selector(state, 'shipAddress2'),
    shipCity: selector(state, 'shipCity'),
    shipZipCode: selector(state, 'shipZipCode'),
    shipState: selector(state, 'shipState'),
    selectedSiteType: selector(state, 'siteType'),
    isBillAddSameAsShipAdd: selector(state, 'isBillAddSameAsShipAdd'),
  };
})(EditForm);
export default reduxForm({
  validate,
  enableReinitialize: true,
  form: 'SiteSetupForm',
})(EditFormComponent);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/EditForm.js